import axios from "axios";

const baseURL = process.env.VUE_APP_BASE_API;
export function request(config) {
  //后期开发如果在多个服务器上调用接口可是实例化多个instance，不同的名字即可
  const instance = axios.create({
    baseURL,
    timeout: 20000,
  });
  //请求拦截
  instance.interceptors.request.use(
    function(config) {
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  //响应拦截
  instance.interceptors.response.use(
    (res) => {
      return res.data;
    },
    (error) => {
      console.log(error);
    }
  );

  return instance(config);
}
